import { render, staticRenderFns } from "./GordianBanner.vue?vue&type=template&id=67ae1df6&"
import script from "./GordianBanner.vue?vue&type=script&lang=js&"
export * from "./GordianBanner.vue?vue&type=script&lang=js&"
import style0 from "./GordianBanner.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports